import { computed, type Ref } from 'vue'

export function useDictionaryLabels(dictionary: Ref<Record<string, string>>) {
    const fallbackLabels = {
        menge: 'Packungsgröße',
        avp: 'AVP',
        pzn: 'PZN',
        zuzahlungsbefreit: 'Zuzahlungsbefreit',
        jetztBestellen: 'Jetzt bestellen',
        wirkstaerkenDarreichungsformen: 'Wirkstärken & Darreichungsformen'
    }

    const labels = computed(() => ({
        menge: dictionary.value['PRODUKTE_table_menge'] ?? fallbackLabels.menge,
        avp: dictionary.value['PRODUKTE_table_avp'] ?? fallbackLabels.avp,
        pzn: dictionary.value['PRODUKTE_table_pzn'] ?? fallbackLabels.pzn,
        zuzahlungsbefreit: dictionary.value['PRODUKTE_Zuzahlungsbefreit'] ?? fallbackLabels.zuzahlungsbefreit,
        jetztBestellen: dictionary.value['PRODUKTE_JetztBestellen'] ?? fallbackLabels.jetztBestellen,
        wirkstaerkenDarreichungsformen: dictionary.value['PRODUKTE_WirkstaerkenDarreichungsformen'] ?? fallbackLabels.wirkstaerkenDarreichungsformen
    }))

    return { labels }
}